import { useState } from "react";
import className from "~/kernel/styling/className";
import Button from "~/ui/Button";
import { ListItem } from "~/ui/List";
import useTranslation from "~/kernel/internationalization/useTranslation";
import type { MainServiceViewObject } from "./buildServicesViewObject";
import { explainPricing } from "~/service/helpers/explainPricing";
import { formatPriceRange, formatTime } from "~/service/shared";

type ServiceListItemProps = { service: MainServiceViewObject; trim?: boolean };

export default function ServiceListItem({
  service,
  trim,
}: ServiceListItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  const { tt, t } = useTranslation("companyServices");

  return (
    <ListItem trim={trim}>
      <div className="space-y-3">
        <div
          className="flex flex-row items-center justify-between"
          key={service.id}
        >
          <div>
            <p>{service.name}</p>
            <p className="text-xs text-slate-500">
              {formatTime(service)}, {formatPriceRange(service)}
            </p>
          </div>
          <div>
            <Button
              variant="muted"
              size="small"
              onClick={() => setIsOpen(!isOpen)}
            >
              {isOpen ? tt("readLess") : tt("readMore")}
            </Button>
          </div>
        </div>
        <p
          className={className("whitespace-pre-line text-sm text-slate-500", {
            hidden: !isOpen,
          })}
        >
          {service.description}
        </p>
        <p
          className={className("whitespace-pre-line text-sm text-slate-500", {
            hidden: !isOpen,
          })}
        >
          {explainPricing(service, { t })}
        </p>
        <p
          className={className("whitespace-pre-line text-sm text-slate-500", {
            hidden: !isOpen || service.addOnServices.length < 1,
          })}
        >
          {tt("optionalAddOns")}{" "}
          {service.addOnServices.map((s) => s.name).join(", ")}
        </p>
      </div>
    </ListItem>
  );
}
